<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원관리</span>
            <span class="txt">
                센터에 등록한 회원님을 검색하실 수 있으며, 회원님의 성함을 눌러 이용권 등록 및 마일리지 등록 등 회원님의
                다양한 설정을 진행하실 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div style="display: flex; gap: 28px">
                <div class="photo-info-card">
                    <img
                        class="photo"
                        :src="customerInfo.imageUrl === null ? '/img/icons/no_photo.jpg' : customerInfo.imageUrl"
                        alt="사진"
                    />
                    <div class="info-txt">
                        <span class="txt name">{{ customerInfo.name + ` (${customerInfo.attendNo})` }}</span>
                        <span class="txt">{{ customerInfo.phone | phoneNumberFilter }}</span>
                        <span class="txt">{{ convertTeamGroupsToString(customerInfo.centerCustomerTeamGroups) }}</span>
                        <span class="txt">-</span>
                    </div>
                    <span v-if="customerInfo.status === 'V'" class="icon green">유효</span>
                    <span v-if="customerInfo.status === 'E'" class="icon red">만료</span>
                    <span v-if="customerInfo.status === '-'" class="icon gray">잠재</span>
                    <span v-if="customerInfo.status === 'H'" class="icon yellow">홀딩</span>
                    <!--<button class="send-btn">인증코드전송</button>-->
                </div>
                <div class="d-flex flex-column" style="margin-top: 35px">
                    <button
                        v-if="hasMessageEvent && customerInfo.mktAgreeSms"
                        class="com-btn white"
                        @click="routing('messageSend', customerInfo)"
                    >
                        메시지 발송
                    </button>
                    <button
                        v-show="isAllowed('ME', 6)"
                        class="com-btn white"
                        style="margin-top: 10px"
                        @click="showContractSendPopup()"
                    >
                        계약서 발송
                    </button>
                </div>
                <div class="info-card">
                    <div class="info-txt">
                        <span class="txt name">최근 수업일</span>
                        <span class="txt">{{ lastLessonDaysAgo }}일전</span>
                        <span class="txt">마지막 출석: {{ customerInfo.latestLessonAt | dateFormatFilter }}</span>
                    </div>
                </div>
            </div>
            <div class="com-tab">
                <button @click="onClickRouter('/madmin/member/info')">기본정보</button>
                <button @click="onClickRouter('/madmin/member/payment')">결제내역</button>
                <button @click="onClickRouter('/madmin/member/cancel')">예약/취소내역</button>
                <button @click="onClickRouter('/madmin/member/attend')">입장/출결내역</button>
                <button @click="onClickRouter('/madmin/member/mileage')">마일리지</button>
                <button
                    @click="
                        checkAllowedClick('MB', 3, () => {
                            onClickRouter('/madmin/member/advice');
                        })
                    "
                >
                    상담내역
                </button>
                <button class="on">메시지발송내역</button>
                <button v-show='isAllowed("ME", 7)' @click="onClickRouter('/madmin/member/contract_send')">계약서발송내역</button>
            </div>

            <div class="com-search-content">
                <div class="line">
                    <div class="com-calendar-wrap">
                        <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                        <div class="com-dash"><span class="dash">~</span></div>
                        <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                    </div>
                    <select-form
                        :select-data="['선택', ...periodTypeList]"
                        :select-value="['', ...periodTypeValueList]"
                        :selected-value="searchPeriod"
                        @update:set="(val) => (searchPeriod = val)"
                    ></select-form>
                </div>
                <div class="line">
                    <select-form
                        :select-data="['발송유형', ...msgTypeList]"
                        :select-value="['', ...msgTypeValueList]"
                        @update:set="(val) => (searchSmsType = val)"
                    ></select-form>
                    <select-form :select-data="['발송자']"></select-form>
                    <!-- 미구현 -->
                    <select-form :select-data="['성공여부']"></select-form>
                    <!-- 미구현 -->
                    <button class="com-search-reset" @click="resetSearchParams"></button>
                </div>
            </div>
            <loading-spinner v-if="messageIsLoading"></loading-spinner>
            <div v-else class="com-table-content">
                <table class="com-table">
                    <colgroup>
                        <col style="width: 240px" />
                        <col style="width: 440px" />
                        <col style="width: 130px" />
                        <col style="width: 130px" />
                        <col style="width: 165px" />
                        <col style="width: 130px" />
                        <col style="width: 180px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>발송시간</th>
                            <th>내용</th>
                            <th>발송유형</th>
                            <th>금액</th>
                            <th>발송자</th>
                            <th>성공여부</th>
                            <th>비고</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(m, index) in messageList" :key="index">
                            <td>{{ m.requestedAt | timestampFilter2 }}</td>
                            <td>
                                <span class="info-line">
                                    <span>{{ m.content }}</span>
                                    <span v-if="m.imageUrl1" class="center">
                                        <a class="com-btn-small blue" href="#" @click="viewImagePop(m.imageUrl1)">
                                            이미지보기
                                        </a>
                                    </span>
                                    <span v-if="m.imageUrl2" class="center">
                                        <a class="com-btn-small blue" href="#" @click="viewImagePop(m.imageUrl2)">
                                            이미지보기
                                        </a>
                                    </span>
                                    <span v-if="m.imageUrl3" class="center">
                                        <a class="com-btn-small blue" href="#" @click="viewImagePop(m.imageUrl3)">
                                            이미지보기
                                        </a>
                                    </span>
                                </span>
                            </td>
                            <td>{{ convertSmsType(m.smsType) }}</td>
                            <!--<td>{{ convertSmsMoney(m.smsType, m.resultCd) }}원</td> db에 있는 값을 보여주도록 변경-->
                            <td>{{ m.price }}원</td>
                            <td>{{ m.sendName }}</td>
                            <td>
                                <span :class="m.resultCd === '1' ? 'success' : 'failure'">
                                    {{ m.resultCd === '1' ? '성공' : '실패' }}
                                </span>
                            </td>
                            <td>{{ m.sendErrorMessage }}</td>
                        </tr>
                        <tr v-if="messageList.length === 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="sort-bottom-area">
                    <select-form
                        :select-data="[...sortTypeList]"
                        :select-value="[...sortTypeValueList]"
                        :selected-value="messagePagingInfo.limit"
                        class="float-right"
                        @update:set="changeLimit"
                    ></select-form>
                </div>
                <b-pagination
                    v-model="messagePagingInfo.page"
                    :per-page="messagePagingInfo.limit"
                    :total-rows="messagePagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation($event)"
                ></b-pagination>
            </div>
        </template>
        <!-- 이미지 미리보기 팝업 -->
        <div v-show="imagePop" class="layer-pop notice-pop">
            <div class="view-content">
                <div class="top-area">
                    <span class="title">미리보기</span>
                    <button class="close-btn" @click="imagePop = false"></button>
                </div>
                <div class="view-area">
                    <img :src="img" alt="" />
                </div>
                <div class="bottom-area">
                    <div class="week-check">
                        <button class="close" @click="imagePop = false">닫기</button>
                    </div>
                </div>
            </div>
        </div>
        <contract-send-dlg
            v-if="contractSendPop"
            :show="contractSendPop"
            :info="contractSendInfo"
            :close="handleCloseContractSend"
            :charge="handleCharge"
            :paymentLinkSend="handlePaymentLinkSend"
        ></contract-send-dlg>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { pagingInfo } from '@/assets/js/common';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import LoadingSpinner from '../../../components/LoadingSpinner';
import ContractSendDlg from '../../../components/ContractSendDlg';

export default {
    name: 'memberMessage',
    mixins: [MixinAllowedMenu],
    components: { LoadingSpinner, ContractSendDlg },
    props: {},
    computed: {
        lastLessonDaysAgo() {
            if (this.customerInfo.latestLessonAt) {
                return moment().startOf('day').diff(moment(this.customerInfo.latestLessonAt).startOf('day'), 'days');
            }

            return '-';
        }
    },
    watch: {
        searchPeriod(newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
            this.fetchMessageList();
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
            this.fetchMessageList();
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;
            this.fetchMessageList();
        },
        searchSmsType(newValue) {
            // 발송유형
            this.searchSmsType = newValue;
            this.fetchMessageList();
        },
    },
    mounted() {
        this.init();
    },
    data() {
        return {
            hasMessageEvent: false, // 메시지 계약되었을시..

            imagePop: false,
            isLoading: false,
            messageIsLoading: false,
            centerId: this.$route.params.id,
            customerId: this.$route.query.customerId,
            customerInfo: {}, // 회원 정보
            messagePagingInfo: { ...pagingInfo },

            msgTypeList: ['SMS', 'LMS', 'MMS', 'KAKAO'], // 발송유형
            msgTypeValueList: ['S', 'L', 'M', 'K'], // 발송유형 value 값

            sortTypeList: ['10줄보기', '20줄보기', '50줄보기', '100줄보기'],
            sortTypeValueList: [10, 20, 50, 100],

            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],

            startDate: '', // 검색시작일자
            endDate: '', // 검색종료일자
            searchPeriod: '', // 검색 기간 설정
            searchSortType: 'DESC', // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
            searchSmsType: '', // 발송유형 (S, L, M)
            searchSendNo: '', // 발송자
            searchSuccess: '', // 성공여부 (true / false)

            messageList: [],
            img: '',

            contractSendPop: false,
            contractSendInfo: {},
            centerInfo: {},
        };
    },
    methods: {
        routing(toName, checkedUserData) {
            const routingData = [];
            console.log(checkedUserData);
            // checkedUserData.forEach((param) => {
            const tempValue = {
                ...checkedUserData,
            };
            routingData.push(tempValue);
            // });
            this.$router.push({
                name: toName,
                params: { data: routingData },
            });
        },

        checkMessageEvent() {
            return api
                .get('/admin/api/center/ftcontract/sms')
                .then((res) => {
                    this.hasMessageEvent = JSON.parse(res.data);
                })
                .catch((error) => {
                    this.hasMessageEvent = false;
                });
        },

        // 초기화
        async init() {
            this.isLoading = true;
            await this.fetchCustomerDetail(); // 회원 정보 가져오기
            await this.fetchMessageList(); // 회원별 메시지 발송 목록 조회
            this.initStartDate();
            this.initEndDate();
            await this.checkMessageEvent();
            this.getCenterInfo(); // 로그인한 센터 정보 가져오기
            this.isLoading = false;
        },
        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },

        showContractSendPopup() {
            this.contractSendInfo = {
                centerId: this.centerId,
                centerName: this.centerInfo.centerName,
                customerId: this.customerId,
                customerName: this.customerInfo.name,
                customerPhone: this.customerInfo.phone,
                templateType: 'M',
            };
            this.contractSendPop = true;
        },

        // 회원 정보 가져오기
        async fetchCustomerDetail() {
            try {
                const { data } = await this.sendGetCustomerDetail();
                this.customerInfo = data;
                this.customerInfo.centerCustomerTeamGroups = this.customerInfo.centerCustomerTeamGroups.filter(
                    (g) => !g.centerCustomerTeam.info.deleteYn
                );
            } catch (error) {
                alert('회원정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 회원 기본정보 조회 API 호출
        sendGetCustomerDetail() {
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}`);
        },
        viewImagePop(img) {
            this.imagePop = true;
            this.img = img;
        },

        // 회원별 메시지 발송 목록 조회
        async fetchMessageList() {
            try {
                this.messageIsLoading = true;
                const { data } = await this.sendGetMessageList();
                this.setPageParams(data);
                this.messageList = data.items;
                this.messageIsLoading = false;
            } catch (error) {
                // alert('메시지 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터회원별 메시지발송 내역 API 호출
        sendGetMessageList() {
            const { startDate, endDate, searchSortType, searchSmsType, searchSendNo, searchSuccess } = this;
            const msgType = 'S'; // 문자만 검색
            const searchParams = {
                msgType,
                sortType: searchSortType, // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
                startDate, // 검색시작일자
                endDate, // 검색종료일자
                smsType: searchSmsType, // 발송유형 (S, L, M)
                sendNo: searchSendNo, // 발송자
                success: searchSuccess, // 성공여부 ( true, false )
            };
            return api.get(`/admin/api/center/${this.centerId}/message/sms/customer/${this.customerId}`, {
                params: {
                    ...this.messagePagingInfo,
                    ...searchParams,
                },
            });
        },

        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            this.endDate = endDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            // this.fetchCustomerMileage();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            // this.fetchCustomerMileage();
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.messagePagingInfo.page = event;
            this.fetchMessageList();
        },

        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}/${this.centerId}`, query: { customerId: this.customerId } });
        },

        // 회원 정보 카드에 나타낼 회원 그룹 이름 만들기
        convertTeamGroupsToString(teamGroups) {
            if (teamGroups === undefined) {
                return;
            }
            if (teamGroups.length === 1) {
                // 그룹이 1개일 경우
                return teamGroups[0].centerCustomerTeamName;
            } else if (teamGroups.length === 0) {
                // 그룹이 없을 경우
                return '-';
            } else if (teamGroups.length > 1) {
                // 그룹이 여러개일 경우
                return `${teamGroups[0].centerCustomerTeamName} 외 ${teamGroups.length - 1}`;
            }
        },

        // 발송 유형 타입 변환
        convertSmsType(type) {
            if (type === 'S') {
                return 'SMS';
            } else if (type === 'L') {
                return 'LMS';
            } else if (type === 'M') {
                return 'MMS';
            } else if (type === 'K') {
                return 'KAKAO';
            }
            return 'SMS';
        },

        convertSmsMoney(type, resultCd) {
            if (resultCd !== '1') {
                return '0';
            }

            if (type === 'S') {
                return '12';
            } else if (type === 'L') {
                return '35';
            } else if (type === 'M') {
                return '90';
            } else if (type === 'K') {
                return '12';
            }
            return '12';
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.messagePagingInfo.limit = val;
            this.fetchMessageList();
        },

        // 페이징 Param 설정
        setPageParams(data) {
            this.messagePagingInfo.totalPages = data.meta.totalPages;
            this.messagePagingInfo.page = data.meta.currentPage;
            this.messagePagingInfo.totalItems = data.meta.totalItems;
            this.messagePagingInfo.itemCount = data.meta.itemCount;
        },

        // 검색 조건 초기화
        resetSearchParams() {
            this.initStartDate(); // 시작일 검색 파라미터
            this.initEndDate(); // 종료일 검색 파라미터
            (this.searchSmsType = ''), // 발송유형 검색 파라미터
                (this.searchSendNo = ''), // 발송자 검색 파라미터
                (this.searchSuccess = ''), // 성공여부 검색 파라미터
                this.fetchMessageList();
            EventBus.$emit('event:initList', 'init');
        },

        handleCloseContractSend() {
            this.contractSendPop = false;
        },

        handleCharge() {
            this.contractSendPop = false;
        },

        handlePaymentLinkSend() {
            this.contractSendPop = false;

            this.onClickRouter('/madmin/member/contract_send');
        },
    },
};
</script>
<style lang="scss"></style>
